import { useEmployeeMe } from "@/queries/employees/use-employees.query.ts";
import { Box } from "@skailer-com/uikit";
import Picker, { EmojiClickData, EmojiStyle } from "emoji-picker-react";
import emojiDataEn from "emoji-picker-react/dist/data/emojis-en";
import emojiDataRu from "emoji-picker-react/dist/data/emojis-ru";
import { getEmojiShortcodeByUnified } from "./emoji-datasource.ts";

export interface EmojiPickerProps {
  onEmojiSelect: (emoji: string) => void;
}

const emojiDataByLanguage = {
  ru: emojiDataRu,
  en: emojiDataEn,
} as const;

export const EmojiPicker = ({ onEmojiSelect }: EmojiPickerProps) => {
  const { data: employee } = useEmployeeMe();
  const employeeLanguage = employee?.language?.toLowerCase().split("-")[0];
  const pickerEmojiData = emojiDataByLanguage[employeeLanguage as keyof typeof emojiDataByLanguage];

  return (
    <Box>
      <Picker
        emojiData={pickerEmojiData ?? emojiDataEn}
        emojiStyle={EmojiStyle.APPLE}
        onEmojiClick={(emoji: EmojiClickData) => {
          const shortcode =
            getEmojiShortcodeByUnified(emoji.unified) ??
            getEmojiShortcodeByUnified(emoji.unifiedWithoutSkinTone);

          onEmojiSelect(shortcode ? `:${shortcode}:` : emoji.emoji);
        }}
        skinTonesDisabled
        previewConfig={{ showPreview: false }}
        lazyLoadEmojis
        width={350}
        height={400}
        getEmojiUrl={(unified) =>
          `${import.meta.env.VITE_CDN_URL}/apple/64/${unified.toLowerCase()}.png`
        }
      />
    </Box>
  );
};
